/** Default financial values per industry (ASP / top3 matching). */
const INDUSTRY_FINANCIAL_DEFAULTS = {
  agriculture: { yearlyrevenue: 200, incominginvoices: 10, outgoinginvoices: 0 },
  art: { yearlyrevenue: 10, incominginvoices: 10, outgoinginvoices: 200 },
  beauty: { yearlyrevenue: 5, incominginvoices: 10, outgoinginvoices: 100 },
  construction: { yearlyrevenue: 50, incominginvoices: 50, outgoinginvoices: 100 },
  courier: { yearlyrevenue: 10, incominginvoices: 0, outgoinginvoices: 500 },
  education: { yearlyrevenue: 10, incominginvoices: 20, outgoinginvoices: 500 },
  etrade: { yearlyrevenue: 10, incominginvoices: 50, outgoinginvoices: 500 },
  finance: { yearlyrevenue: 50, incominginvoices: 0, outgoinginvoices: 0 },
  IT: { yearlyrevenue: 50, incominginvoices: 20, outgoinginvoices: 200 },
  lawyer: { yearlyrevenue: 10, incominginvoices: 20, outgoinginvoices: 10 },
  logistics: { yearlyrevenue: 10, incominginvoices: 20, outgoinginvoices: 20 },
  manufacturing: { yearlyrevenue: 50, incominginvoices: 10, outgoinginvoices: 10 },
  medicine: { yearlyrevenue: 50, incominginvoices: 0, outgoinginvoices: 20 },
  other: { yearlyrevenue: 10, incominginvoices: 10, outgoinginvoices: 500 },
  otherservices: { yearlyrevenue: 10, incominginvoices: 10, outgoinginvoices: 10 },
  realestate: { yearlyrevenue: 50, incominginvoices: 10, outgoinginvoices: 10 },
  startup: { yearlyrevenue: 10, incominginvoices: 50, outgoinginvoices: 50 },
  retail: { yearlyrevenue: 50, incominginvoices: 20, outgoinginvoices: 20 },
  wholesale: { yearlyrevenue: 50, incominginvoices: 20, outgoinginvoices: 20 },
  travel: { yearlyrevenue: 50, incominginvoices: 50, outgoinginvoices: 500 },
  vehicle: { yearlyrevenue: 200, incominginvoices: 50, outgoinginvoices: 100 },
  sport: { yearlyrevenue: 50, incominginvoices: 20, outgoinginvoices: 20 },
  consultancy: { yearlyrevenue: 10, incominginvoices: 10, outgoinginvoices: 10 },
  engineer: { yearlyrevenue: 10, incominginvoices: 10, outgoinginvoices: 10 },
};

const FALLBACK_DEFAULTS = {
  yearlyrevenue: 5,
  incominginvoices: 0,
  outgoinginvoices: 0,
};

export const getIndustryFinancialDefaults = (industry) => {
  if (!industry) {
    return null;
  }
  return INDUSTRY_FINANCIAL_DEFAULTS[industry] ?? FALLBACK_DEFAULTS;
};
